var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Mes")]),_c('th',[_vm._v("Cuota Promedio Teórica")]),_c('th',[_vm._v("Recaudo Teórico")]),_c('th',[_vm._v("Recaudo Real")]),_c('th',[_vm._v("Interés Teórico")]),_c('th',[_vm._v("Interés Real")]),_c('th',[_vm._v("# Cuotas")]),_c('th',[_vm._v("% Recaudo")]),_c('th',[_vm._v("% Cuotas")])])])
}]

export { render, staticRenderFns }